module.exports = __webpack_public_path__ + "img/case-m-banner.786fb4e0.png";